import React, { Component } from 'react';
import './App.css';

const divStyle = {
  margin: 'auto',
  padding: '20px',
  maxWidth: '600px',
  display: 'flex', 
  flexDirection: 'column',
  alignItems: 'center'
};

class Privacy extends Component {

  render() {
    return (
      <div style={divStyle}>
        <h1>Beefcake</h1>
        <h2>Privacy policy</h2>
        By installing our mobile application or in other way using or accessing our Services, you accept the terms and conditions of this Privacy Policy and the processing of your personal data.

        <h2>Authors</h2>
        Magnus Bondesson and Patrik Åkerlund, Sweden

        <h2>Personal data</h2>
        You can store images connected to your exercises in the app. They are only stored on your local phone, in the sense that we don't send or save them anywhere else. The Beefcake database can be exported, it's then saved locally or in the cloud if you decide to do so.

        <h2>Analytics</h2>
        We use mobile analytics software to allow us to better understand the functionality of our Mobile Software on your phone. This software may record information such as how often you use the application, the events that occur within the application, aggregated usage, performance data, and from where the application was downloaded.

        <h2>Bugtracking</h2>
        We use a bugtracking tool called Instabug that user can use to send us bug reports or give feedback. Instabug lets the user add screenshots and record audio. This is the
        reason the app requires a permission for recording audio.

        <h2>Security</h2>
        We will use commercially reasonable efforts to safeguard the confidentiality of your personal information. However, we cannot be held liable for any loss of or disclosure of data or any losses or damages incurred due to errors in transmission or unauthorized or unlawful acts of third parties or your decision to disclose your personal information.

        <h2>Changes to privacy policy</h2>
        From time to time, it may become necessary to make changes to this Privacy Policy. Therefore, we reserve the right to update and/or modify this Privacy Policy at any time. Please review this Privacy Policy frequently. The date of the last modification is listed at the bottom of this Privacy Policy.

        <h2>Contact</h2>
        If you have any questions or suggestions regarding our Privacy Policy, please contact us at pamb.software@gmail.com

        <h2>Last modified</h2>
        Aug 6, 2018

      </div>
    );
  }
}

export default Privacy;



// WEBPACK FOOTER //
// ./src/Privacy.js